import Image from "next/image";
import cn from "classnames";
import { useMediaQuery } from "@hooks/useMediaQuery";
import { useStore } from "@hooks/useZustandProvider";
import Editor from "@ui-kit/cms/Editor/Editor";
import Container from "@ui-kit/Container/Container";
import Dropzone from "@ui-kit/Dropzone/Dropzone";
import EditableLink from "@components/cms/EditableLink/EditableLink";
import {
  commonBlocksOptions,
  specificBlockOptions,
} from "@components/cmsBlocks/configs";
import s from "./BannerBlock.module.scss";

const BannerBlock = ({ settings, data, updateField }) => {
  const { cms } = useStore();
  const { isMobile } = useMediaQuery();
  const { isEditMode } = cms.uiOptions;
  const {
    title,
    content1,
    image,
    blockBackgroundImage,
    blockBackgroundImageMobile,
    link,
    showMore
  } = data;
  const { blockType } = settings.common;

  const { picture, titlePosition, showMoreLink, typeOfLink } = settings.specific;

  const isButtonTypeLink = typeOfLink?.value === specificBlockOptions.banner.typeOfLink.options[0].value;
  const isTitleOutside =
    titlePosition.value ===
    specificBlockOptions.banner.titlePosition.options[0].value;

  const enabledPicture = picture.value !== "none";
  const isRenderPicture = enabledPicture && image.src;

  const pictureRight = enabledPicture && picture.value === "right";

  const updateShowMoreLink = (value) => {
    updateField({
      name: "link",
      value,
    });
  };

  const background =
    blockBackgroundImage || blockBackgroundImageMobile
      ? `url(${isMobile
        ? blockBackgroundImageMobile || blockBackgroundImage
        : blockBackgroundImage
      })`
      : "";

  const isH2 =
    blockType.value === commonBlocksOptions.blockType.options[0].value;

  return (
    <Container
      className={s.bannerBlock}
      cursorNotice="Double click to edit banner"
    >
      <Container
        full={false}
        cursorNotice="Double click to edit banner"
        className={s.innerBannerBlock}
      >
        <section
          style={{
            backgroundImage: background,
          }}
          className={cn(
            s.section,
            enabledPicture && s.enabledPicture,
            pictureRight && s.pictureRight,
            background && s.withBackground,
            !isTitleOutside && s.titleInside
          )}
        >
          {isTitleOutside && (
            <h2 className={cn(s.title, isH2 && s.red)}>
              <Editor field={{ title }} onChange={updateField} onlyText />
            </h2>
          )}

          {enabledPicture && isEditMode ? (
            <Dropzone
              className={cn(s.picture, s.dropdown, !image.src && s.empty)}
              onDrop={(path) => {
                updateField({
                  name: "image",
                  value: {
                    ...image,
                    src: path,
                  },
                });
              }}
              preview={image.src}
              removeImage={() => {
                updateField({
                  name: "image",
                  value: {
                    ...image,
                    src: "",
                  },
                });
              }}
            />
          ) : (
            isRenderPicture && (
              <div className={s.picture}>
                <Image
                  width={0}
                  height={0}
                  sizes="100vw"
                  src={image.src}
                  alt={image.alt}
                  style={{ width: "100%", height: "auto" }}
                />
              </div>
            )
          )}

          <div className={s.texts}>
            {!isTitleOutside && (
              <h2 className={cn(s.title, isH2 && s.red)}>
                <Editor field={{ title }} onChange={updateField} onlyText />
              </h2>
            )}
            <div className={s.text}>
              <Editor field={{ content1 }} onChange={updateField} />
            </div>
            {showMoreLink.value && (
              <EditableLink
                isButtonTypeLink={isButtonTypeLink}
                link={link}
                data={showMore}
                onChange={updateShowMoreLink}
                className={s.showMore}
              />
            )}
          </div>
        </section>

      </Container>
    </Container>
  );
};

export default BannerBlock;
